var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcEdit04({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-04"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.74498 2.80094C10.2654 2.28021 11.1094 2.27985 11.6303 2.80015L13.1993 4.36732C13.7204 4.88783 13.7207 5.73226 13.2001 6.25321L6.56151 12.8954C6.3758 13.0812 6.13934 13.208 5.88181 13.2599L2.93166 13.8544C2.71275 13.8985 2.4863 13.83 2.32844 13.6721C2.17058 13.5141 2.10229 13.2876 2.14652 13.0688L2.74202 10.1221C2.79396 9.86512 2.92052 9.62914 3.10587 9.44369L9.74498 2.80094ZM12.257 5.31066L10.688 3.74349L4.04893 10.3862L3.65227 12.349L5.61844 11.9528L12.257 5.31066Z",
    fill: "#116584"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit04);
export default __webpack_public_path__ + "static/media/ic-edit-04.628b62ac54f08d84ebfc981263fc3ebb.svg";
export { ForwardRef as ReactComponent };